import { RefObject, useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import GymChainAccessCategoryInfoTemplate from '../../templates/GymChainAccessCategoryInfo/GymChainAccessCategoryInfo';
import { fetchGymChainAccessCategory } from '../../../redux/slices/gymChainAccessCategorySlice';
import Loader from '@gym-atoms/Loader/Loader';

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const dispatch = useAppDispatch();
  const { gymChainAccessCategoryId, chainId } = useParams<{
    gymChainAccessCategoryId: string;
    chainId: string;
  }>();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      fetchGymChainAccessCategory({
        siteId: +chainId
      })
    );
  }, [chainId, dispatch]);

  const gymChainAccessCategory = useAppSelector((state) =>
    state.gymChainAccessCategories.items
      .find((g) => g.siteId === +chainId)
      ?.items.find((g) => g.id === +gymChainAccessCategoryId)
  );

  const gymChainAccessCategoryState = gymChainAccessCategory
    ? {
        id: gymChainAccessCategory.id || 0,
        siteId: gymChainAccessCategory.siteId || 0,
        name: gymChainAccessCategory.name || '',
        gender: gymChainAccessCategory.gender || '',
        age: gymChainAccessCategory.age || 0,
        schedulesOnly: gymChainAccessCategory.schedulesOnly || 'true',
        status: gymChainAccessCategory.status || '',
        gyms: [],
        memberships: [],
        groupId: gymChainAccessCategory.arxAccessCategoryId || ''
      }
    : undefined;

  if (!gymChainAccessCategoryState) {
    return (
      <Card className="pt30 pl40 pr40 pb30">
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
      </Card>
    );
  }

  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainAccessCategoryInfoTemplate
        alertRef={props.alertRef}
        alertMessage={t('MODIFY_MEMBERSHIP.ALERT_MESSAGE_SUCCESS')}
        accessCategory={gymChainAccessCategoryState}
        type={'modify'}
      />
    </Card>
  );
};

const ModifyGymChainAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId } = useParams<{ chainId: string }>();

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(`/gymChains/${chainId}/gymChainAccessCategories`)}
    />
  );
};
export default ModifyGymChainAccessCategoryPage;
